module.exports = __webpack_public_path__ + "static/media/img_29tv04.3e0a76aa.jpg";